<template>
    <div>
        <el-radio-group v-model="humanSide" fill="#833e93" text-color="#ffffff" size="small">
            <el-radio-button label="Front"></el-radio-button>
            <el-radio-button label="Back"></el-radio-button>
        </el-radio-group>

        <div class="human-map-wrapper">
            <div key="body">
                <body_f
                    v-if="humanSide === 'Front'"
                    :key="selectedParts.length"
                    :color="isFrontAllPartsSelected ? '#833E93' : '#B2B2B2'"
                    class="body_f">
                </body_f>
                <body_b
                    v-if="humanSide === 'Back'"
                    :key="selectedParts.length"
                    :color="isBackAllPartsSelected ? '#833E93' : '#B2B2B2'"
                    class="body_b">
                </body_b>
            </div>
            <div v-for="bodyPart in humanMap" :key="bodyPart.id">
                <template v-if="bodyPart.side.toLowerCase() === humanSideLowerCase">
                    <div class="tooltip" v-if="selectedParts.filter(bp => bp.id === bodyPart.id).length">
                        <span :ref="bodyPart.id + '_tooltip'" class="tooltiptext">{{ bodyPart.tooltip }}</span>
                    </div>
                    <div 
                        :is="bodyPart.id === 'head' ? 'head_map' : bodyPart.id" 
                        :ref="bodyPart.id"
                        :key="selectedParts.length" 
                        :class="bodyPart.id"  
                        @click.native="toggle(bodyPart.id)" 
                        :color="selectedParts.filter(bp => bp.id === bodyPart.id).length ? '#833E93' : '#CCCCCC'">
                    </div>
                </template>
            </div>
        </div>
        <div class="selected-text">
            <span v-if="calcSelectedList['Front'].length" style="margin-top: 20px; ">Front<br>
                <span v-for="part in calcSelectedList['Front']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
            <br><br>
            <span v-if="calcSelectedList['Back'].length" style="margin-top: 10px;">Back<br>
                <span v-for="part in calcSelectedList['Back']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { RadioGroup, RadioButton } from 'element-ui'
    import SubQuestion from './index'
    import IconComponents from '../icon/Hand/components'

    Vue.use(RadioGroup)
    Vue.use(RadioButton)

    const humanMap = [
        { id: 'thumb_f', side: 'Front', tooltip: 'Thumb (F)' },
        { id: 'index_finger_f', side: 'Front', tooltip: 'Index Finger (F)' },
        { id: 'middle_finger_f', side: 'Front', tooltip: 'Middle Finger (F)' },
        { id: 'ring_finger_f', side: 'Front', tooltip: 'Ring Finger (F)' },
        { id: 'pinky_finger_f', side: 'Front', tooltip: 'Pinky Finger (F)' },
        { id: 'palm', side: 'Front', tooltip: 'Palm' },
        { id: 'wrist_f', side: 'Front', tooltip: 'Wrist (F)' },

        { id: 'thumb_b', side: 'Back', tooltip: 'Thumb (B)' },
        { id: 'index_finger_b', side: 'Back', tooltip: 'Index Finger (B)' },
        { id: 'middle_finger_b', side: 'Back', tooltip: 'Middle Finger (B)' },
        { id: 'ring_finger_b', side: 'Back', tooltip: 'Ring Finger (B)' },
        { id: 'pinky_finger_b', side: 'Back', tooltip: 'Pinky Finger (B)' },
        { id: 'back_of_hand', side: 'Back', tooltip: 'Back of Hand (Dorsal) (B)' },
        { id: 'wrist_b', side: 'Back', tooltip: 'Wrist (B)' },
    ]

    export default {
        name: 'hand',
        extends: SubQuestion,
        watch: {
            humanSide: function() {
                this.$nextTick(() => this.removeTooltips())
                this.$emit('changeHumanMapSide', this.humanSide)
            }
        },

        props: {
            saved: {
                type: Array
            }
        },

        data() {
            return {
                humanMap: JSON.parse(JSON.stringify(humanMap)),
                humanSide: 'Front',
                selectedParts: [] || this.saved,
                unsortedBodyParts: [] || this.saved,
                frontTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Front"),
                backTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Back"),
                normalizeHumanMap: JSON.parse(JSON.stringify(humanMap)).reduce((acc,ele) => {
                    return { ...acc, [ele.id]: { ...ele }}
                }, {})
            }
        },

        mounted() {
            this.loadData()
            this.$emit('changeHumanMapSide', this.humanSide)
        },

        methods: {
            /**
             * @func placeTooltip
             * @desc places tooltip on body part selection
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            placeTooltip(bodyPart) {
                let imgRef = this.$refs[bodyPart][0].$el
                let tooltipRef = this.$refs[bodyPart + '_tooltip'][0]
                tooltipRef.style.visibility = 'visible'

                let top = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('top').replace('px', ''))
                let left = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('left').replace('px', ''))

                tooltipRef.style.top = (top + 80) + 'px'
                // for body parts on right side of the screen
                if ((this.humanSide === 'Front' && bodyPart.includes('left')) || (this.humanSide === 'Back' && bodyPart.includes('right'))) {
                    tooltipRef.style.left = (left - 60) + 'px'
                }
                // for body parts on left side of the screen
                else if ((this.humanSide === 'Front' && bodyPart.includes('right')) || (this.humanSide === 'Back' && bodyPart.includes('left'))) {
                    tooltipRef.style.left = (left - 30) + 'px'
                }
                else if(['pinky_finger_f', 'thumb_b', 'index_finger_b'].includes(bodyPart))
                    tooltipRef.style.left = (left - 60) + 'px'
                // for head
                else if(bodyPart.includes('head') || bodyPart.includes('neck') || bodyPart.includes('throat') || bodyPart.includes('knee') || bodyPart.includes('abdomen')) {
                    tooltipRef.style.top = (top + 50) + 'px'
                    tooltipRef.style.left = (left) + 'px'
                }
                // for middle body parts
                else tooltipRef.style.left = (left + 10) + 'px'
            },
            /**
             * @func removeTooltips
             * @desc removes all tooltips
             * @param tooltipText(String)
             */
            removeTooltips(tooltipText) {
                if (document.getElementsByClassName('tooltiptext')) {
                    let classes = document.getElementsByClassName('tooltiptext')
                    Object.keys(classes).forEach(cls => {
                        if (!tooltipText || (tooltipText && classes[cls].innerHTML.trim() === tooltipText))
                            classes[cls].style.visibility = 'hidden'
                    })
                }
            },
            loadData() {
                if (!this.saved) this.$emit('selectbp', [])
                else {
                    this.unsortedBodyParts = this.saved
                    this.selectedParts = this.saved
                    this.sortBodyParts()
                    this.$emit('selectbp', this.saved)
                }
                this.$nextTick(() => this.removeTooltips())
            },
            /**
             * @func toggle
             * @desc toggles the state of body part
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            toggle(bodyPart) {
                // making inactive
                if (this.selectedParts.filter(bp => bp.id === bodyPart).length) {
                    this.selectedParts = this.selectedParts.filter(part => part.id !== bodyPart)
                    this.unsortedBodyParts = this.unsortedBodyParts.filter(part => part.id !== bodyPart)
                }
                // making active
                else {
                    if (this.limitReached(this.humanSide)) 
                        return

                    let tooltipText = ''
                    let reqObj = {
                        id: bodyPart,
                        value: bodyPart
                    }

                    this.selectedParts.push(reqObj)
                    this.unsortedBodyParts.push(reqObj)

                    tooltipText = this.humanMap.filter(bp => bp.id === bodyPart)[0].tooltip
                    // placing tooltip on top of the body part
                    this.$nextTick(() => this.placeTooltip(bodyPart))
                    // remove tooltip after 1.5seconds
                    setTimeout(() => this.removeTooltips(tooltipText), 1500)
                }
                // sort
                this.sortBodyParts()
                this.$emit('selectbp', this.selectedParts)
            },
            sortBodyParts() {
                let tempSelectedParts = []
                this.humanMap.forEach(bp => {
                    this.selectedParts.forEach(sp => {
                        if (sp.value === bp.id) tempSelectedParts.push(sp)
                    })
                })
                this.selectedParts = tempSelectedParts
            },
        },

        computed: {
            humanSideLowerCase() {
                return this.humanSide.toLowerCase()
            },
            calcSelectedList() {
                let selectedList = { 'Front': [], 'Back': [] }
                this.unsortedBodyParts.forEach(part => {
                    let partObj = this.humanMap.filter(bodyPart => part.value === bodyPart.id)[0]
                    if(partObj) {
                        selectedList[partObj.side].push(partObj.tooltip)
                    }
                })
                return selectedList
            },
            isFrontAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Front").length === this.frontTotalParts.length
            },
            isBackAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Back").length === this.backTotalParts.length
            }
        },

        components: {
            ...IconComponents
        },
    }
</script>

<style lang="scss" scoped>
    $choice-size: 150px;
    $choice-font-size: 20px;
    @import "style.scss";

    .thumb_f {
        position: absolute;
        top: 170px;
        left: 80px;
    }

    .thumb_b {
        position: absolute;
        top: 170px;
        right: 40px;
    }

    .index_finger_f {
        position: absolute;
        top: 80px;
        left: 120px;
    }

    .index_finger_b {
        position: absolute;
        top: 78px;
        right: 83px;
    }

    .middle_finger_f {
        position: absolute;
        top: 60px;
        left: 160px;
    }

    .middle_finger_b {
        position: absolute;
        top: 58px;
        right: 122px;
    }

    .ring_finger_f {
        position: absolute;
        top: 75px;
        left: 195px;
    }


    .ring_finger_b {
        position: absolute;
        top: 73px;
        right: 155px;
    }

    .pinky_finger_f {
        position: absolute;
        top: 115px;
        left: 225px;
    }

    .pinky_finger_b {
        position: absolute;
        top: 112px;
        right: 180px;
    }

    .palm {
        position: absolute;
        top: 173px;
        left: 125px;
    }

    .back_of_hand {
        position: absolute;
        top: 173px;
        right: 85px;
    }

    .wrist_f {
        position: absolute;
        top: 305px;
        left: 145px;
    }

    .wrist_b {
        position: absolute;
        top: 305px;
        right: 105px;
    }

    .human-map-wrapper {
        min-height: 450px;
    }

</style>
